 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import DEDICATION from '@/components/Dedication'
 import EPIGRAPH from '@/components/Epigraph'
 import NAV from '@/components/nav'
 import MAP_2 from '@/components/Map_2'
 import MAP_3 from '@/components/Map_3'
 import MAP_1 from '@/components/Map_1'
 import MAP_4 from '@/components/Map_4'
 import PROLOGUE from '@/components/Prologue'
 import CHAPTER_1_HEPHAESTUS_AWAK from '@/components/Chapter_1_Hephaestus_Awak'
 import CHAPTER_2_FROM_THE_GRAVES from '@/components/Chapter_2_From_the_Graves'
 import CHAPTER_3_ADAPTATION from '@/components/Chapter_3_Adaptation'
 import CHAPTER_4_DEAD_OF_NIGHT from '@/components/Chapter_4_Dead_of_Night'
 import CHAPTER_5_PLUM_ISLAND_RIS from '@/components/Chapter_5_Plum_Island_Ris'
 import CHAPTER_6_IT_CAME_FROM_BE from '@/components/Chapter_6_It_Came_from_Be'
 import CHAPTER_7_LYSENKO from '@/components/Chapter_7_Lysenko'
 import CHAPTER_8_ALL_THE_REMAINS from '@/components/Chapter_8_All_the_Remains'
 import CHAPTER_9_SEEING_RED from '@/components/Chapter_9_Seeing_Red'
 import CHAPTER_10_A_MEETING_WITH from '@/components/Chapter_10_A_Meeting_with'
 import CHAPTER_11_SECRET_WARS from '@/components/Chapter_11_Secret_Wars'
 import CHAPTER_12_CODES_AND_CONS from '@/components/Chapter_12_Codes_and_Cons'
 import CHAPTER_13_WHAT_AN_OCTOPU from '@/components/Chapter_13_What_an_Octopu'
 import CHAPTER_14_IMMORTAL_SINS from '@/components/Chapter_14_Immortal_Sins'
 import CHAPTER_15_BEYOND_THE_SPE from '@/components/Chapter_15_Beyond_the_Spe'
 import CHAPTER_16_A_STUDY_IN_SCA from '@/components/Chapter_16_A_Study_in_Sca'
 import CHAPTER_17_FUTURE_PRIMITI from '@/components/Chapter_17_Future_Primiti'
 import CHAPTER_18_CHAINS_OF_COMM from '@/components/Chapter_18_Chains_of_Comm'
 import CHAPTER_19_ICARUS from '@/components/Chapter_19_Icarus'
 import CHAPTER_20_ANGER_DENIAL_A from '@/components/Chapter_20_Anger_Denial_A'
 import EPILOGUE_THE_DESCENT_OF_M from '@/components/Epilogue_The_Descent_of_M'
 import PART_1_YANNI_THE_QUEST from '@/components/Part_1_Yanni_The_Quest'
 import PART_2_THE_DARWIN_STRAIN_ from '@/components/Part_2_The_Darwin_Strain_'
 import LOVE_2 from '@/components/love_2'
 import AUTHORS_NOTE_REALITY_CHEC from '@/components/Authors_Note_Reality_Chec'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import SELECTED_BIBLIOGRAPHY from '@/components/Selected_Bibliography'
 import ABOUT_THE_AUTHORS from '@/components/About_the_Authors'
 import CARD_PAGE from '@/components/Card_Page'
 import BOOK_PERK_AD from '@/components/Book_Perk_Ad'
 import COPYRIGHT_ELECTRONIC from '@/components/Copyright_electronic'
 import ABOUT_THE_PUBLISHER from '@/components/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Epigraph",
 			"name" : "Epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/Map_2",
 			"name" : "Map_2",
 			"component" : MAP_2
 		},
 		{
 			"path" : "/Map_3",
 			"name" : "Map_3",
 			"component" : MAP_3
 		},
 		{
 			"path" : "/Map_1",
 			"name" : "Map_1",
 			"component" : MAP_1
 		},
 		{
 			"path" : "/Map_4",
 			"name" : "Map_4",
 			"component" : MAP_4
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Chapter_1_Hephaestus_Awak",
 			"name" : "Chapter_1_Hephaestus_Awak",
 			"component" : CHAPTER_1_HEPHAESTUS_AWAK
 		},
 		{
 			"path" : "/Chapter_2_From_the_Graves",
 			"name" : "Chapter_2_From_the_Graves",
 			"component" : CHAPTER_2_FROM_THE_GRAVES
 		},
 		{
 			"path" : "/Chapter_3_Adaptation",
 			"name" : "Chapter_3_Adaptation",
 			"component" : CHAPTER_3_ADAPTATION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js